import type { FC } from 'react';
import { useLogo } from '@hooks';
import styles from './OrgLogo.module.css';

/**
 * Customer organization logo, rendered in the `@dynamon-as/ui` Header
 * logo slot. Renders nothing while the organization has no logo.
 */
const OrgLogo: FC = () => {
    const { logoUrl } = useLogo();

    if (!logoUrl) {
        return null;
    }

    return (
        <img
            className={styles.orgLogo}
            alt="Organisasjonslogo"
            src={logoUrl}
        />
    );
};

export default OrgLogo;
